import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../environments/environment";
import { ConfigurationKeys } from '../../enum/configuration-keys.enum';

@Injectable()
export class TenantConfigService {
    private baseUrl = environment.BASE_PATH;

    private defaultInitialMapConfiguration = {
        style: 'mapbox://styles/mapbox/light-v11',
        center: [environment.START_LNG, environment.START_LAT],
        zoom: 12,
    }

    constructor(
        private readonly http: HttpClient,
    ) { }

    private async getConfig(key: string) {
        const url = `${this.baseUrl}/tenant-config/${key}`;
        const result$ = this.http.get<string>(url);
        const result = await firstValueFrom(result$);

        return result;
    }

    async getInitialMapConfiguration() {
        try {
            const value = await this.getConfig(ConfigurationKeys.INITIAL_MAP_CONFIGURATION);
            return JSON.parse(JSON.stringify(value));
        } catch (e) {
            console.error(`Failed to get initial map configuration: ${e}`);
            return this.defaultInitialMapConfiguration;
        }
    }

}
